const styles = (theme) => ({
    paper: {
        overflow: 'hidden',
    },
    topoFiltros: {
        marginBottom: '5px',
        borderBottom: '1px solid #efefef',
    },
    circle: {
        backgroundColor: theme.palette.primary.main,
        width: 10,
        height: 10,
        borderRadius: '50%',
    },
    lista: {
        width: '100%',
        maxWidth: 360,
        padding: '0',
        backgroundColor: theme.palette.background.paper,
    },
    boxFiltros: {
        maxHeight: '800px',
        minHeight: '530px',
        overflowY: 'scroll',
        overflowX: 'hidden',
    },
    boxIntFiltros: {
        padding: '20px',
        borderBottom: '1px solid #efefef',
    },
    boxBtnFiltrar: {
        height: '50px',
        marginTop: '50px',
        textAlign: 'center',
        backgroundColor: theme.palette.primary.dark,
    },
    expansionPanelDetails: {
        flexDirection: 'column',
    },
    titleList: {
        '& span': {
            fontSize: '12px',
        },
    },
    filterLabel: {
        '& span': {
            fontSize: '14px',
        },
    },
    centerProgress: {
        marginTop: '5px',
        textAlign: 'center',
    },
    btnFiltrar: {
        marginTop: '-22px',
        height: '45px',
        borderRadius: '30px',
        padding: '10px 30px',
    },
    btnFiltrarDisabled: {
        marginTop: '-22px',
        height: '45px',
        borderRadius: '30px',
        padding: '10px 30px',
        backgroundColor: 'rgb(136,178,214) !important',
        color: '#ffffff !important',
    },
    linhaFiltroData: {
        width: '100%',
    },
    containerItemList: {
        padding: '4px 20px 4px 0px',
    },
    listItemIcon: {
        minWidth: '0',
    },
    listItemSecondaryAction: {
        right: '5px',
    },
});

export default styles;
